import { render, staticRenderFns } from "./official_task_list.vue?vue&type=template&id=2a53ca4e&scoped=true&"
import script from "./official_task_list.vue?vue&type=script&lang=js&"
export * from "./official_task_list.vue?vue&type=script&lang=js&"
import style0 from "./official_task_list.vue?vue&type=style&index=0&id=2a53ca4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a53ca4e",
  null
  
)

export default component.exports